<kendo-editor
  class="ti-edit-box"
  [tiRichTextAutoSize]="true"
  [readonly]="effectiveReadonly()"
  [class.ti-no-data-editor]="effectiveReadonly() && !valueModel()"
  [class.no-cursor]="effectiveReadonly()"
  [iframe]="false"
  [value]="editorValue()"
  (valueChange)="onEditorValueChange($event)"
  [resizable]="resizableValue()">
  <kendo-toolbar [overflow]="true" [popupSettings]="{ popupClass: 'ti-rich-text-toolbar-popu' }">
    @if (buttonsConfig()?.showFontButtons) {
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorItalicButton themeColor="tertiary"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorBoldButton themeColor="tertiary"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorUnderlineButton themeColor="tertiary"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorStrikethroughButton themeColor="tertiary"> </kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
    }
    @if (buttonsConfig()?.showAlignButtons) {
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorAlignLeftButton themeColor="tertiary"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAlignCenterButton themeColor="tertiary"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAlignRightButton themeColor="tertiary"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAlignJustifyButton themeColor="tertiary"> </kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
    }
    @if (buttonsConfig()?.showFormatButton) {
      <kendo-toolbar-dropdownlist kendoEditorFormat #kendoEditorFormat></kendo-toolbar-dropdownlist>
    }
    @if (buttonsConfig()?.showBackColorButton) {
      <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
    }
    @if (buttonsConfig()?.showForeColorButton) {
      <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
    }
    @if (buttonsConfig()?.showListButtons) {
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorInsertUnorderedListButton themeColor="tertiary"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorInsertOrderedListButton themeColor="tertiary"> </kendo-toolbar-button>
        @if (buttonsConfig()?.showIndentButton) {
          <kendo-toolbar-button kendoEditorIndentButton themeColor="tertiary"> </kendo-toolbar-button>
        }
        @if (buttonsConfig()?.showOutdentButton) {
          <kendo-toolbar-button kendoEditorOutdentButton themeColor="tertiary"> </kendo-toolbar-button>
        }
      </kendo-toolbar-buttongroup>
    }
    @if (buttonsConfig()?.showLinkButtons) {
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button createLinkDirective themeColor="tertiary" showText="menu"> </kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorUnlinkButton themeColor="tertiary"> </kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
    }
    @if (buttonsConfig()?.showInsertTableButton) {
      <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
    }
    @if (buttonsConfig()?.showInsertImageButton) {
      <kendo-toolbar-button insertImageDirective themeColor="tertiary" showText="menu"></kendo-toolbar-button>
    }

    @if (buttonsConfig()?.showFontSizeButton) {
      <kendo-toolbar-dropdownlist kendoEditorFontSize #kendoEditorFontSize></kendo-toolbar-dropdownlist>
    }
    @if (buttonsConfig()?.showFontFamilyButton) {
      <kendo-toolbar-dropdownlist kendoEditorFontFamily #kendoEditorFontFamily></kendo-toolbar-dropdownlist>
    }
    @if (buttonsConfig()?.showAdditionalButtons) {
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button
      ></kendo-toolbar-buttongroup>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button
      ></kendo-toolbar-buttongroup>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button
      ></kendo-toolbar-buttongroup>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button
      ></kendo-toolbar-buttongroup>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button
      ></kendo-toolbar-buttongroup>

      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
    }
  </kendo-toolbar>
</kendo-editor>
